import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", function() {

    let targetSelector;
    if (document.body.classList.contains('elementor-page')) {
        targetSelector = '.entry-content > div:first-child > *';
    } else {
        targetSelector = '.site-main > *';
    }

    gsap.utils.toArray(targetSelector).forEach(element => {
        const hasStickyNav = element.querySelector('.sticky-page-nav');
        if (!hasStickyNav) {
            gsap.fromTo(element,
                { opacity: 0.001, y: 20 },  // Initial state
                {
                    y: 0,
                    opacity: 1,  // Final state
                    duration: 2,
                    scrollTrigger: {
                        trigger: element,
                        start: 'top 80%',
                        end: 'top 20%',
                        scrub: false,
                    },
                }
            );
        }
    });
});
